import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function LatestArticles() {
  const latest = articles.slice(3, 9);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900"
              style={{ fontFamily: "var(--font-heading)" }}>
              最新文章
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">
              持续更新，保持你的po文知识库永远最新
            </p>
          </div>
          <Link
            to="/category/tips"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/tips"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}